<template>
  <div id="UpdateUserInfo">
    <div class="pt-1">
      <div class="m-2">
        <van-cell class="text-left border-radius">
          <van-field v-model="RealName" label="姓名" placeholder="姓名" />
          <van-field v-model="UserIDCard" label="身份证" placeholder="身份证" />
          <van-field v-model="Phone" label="手机号" placeholder="手机号" />
        </van-cell>

        <van-button plain hairline type="primary w-100 mt-4" @click="setPwdBtn"
          >修改信息</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UpdateUserInfo",
  data () {
    return {
      RealName: "",
      UserIDCard: "",
      Phone: ""
    };
  },
  methods: {
    setPwdBtn: function () {
      if (this.RealName == "") {
        this.$toast("请输入姓名")
        return
      }
      if (this.UserIDCard == "") {
        this.$toast("请输入身份证")
        return
      }
      if (this.Phone == "") {
        this.$toast("请输入手机号")
        return
      }
      const arr = Array.from(this.UserIDCard);
      if (arr.length != 18) {
        this.$toast('身份证格式错误，请重新输入');
        return
      }
      var regExp = /^1[23456789]\d{9}$/;
      if (!regExp.test(this.Phone)) {
        this.$toast('手机号格式错误，请重新输入');
        return
      }
      var json = {
        RealName: this.RealName,
        UserIDCard: this.UserIDCard,
        Phone: this.Phone,
        Flg: 'other'
      };
      this.apiUserPut(json, this, e => {
        this.$toast(e.message);
        if (e.code == 20000) {
          this.$router.push({
            name: "ExamManage"
          });
        }
      });
    }
  },
  created () {
    this.apiUserGet(this, res => {
      this.RealName = res.data.RealName;
      this.UserIDCard = res.data.UserIDCard;
      this.Phone = res.data.Phone;
    });
  }
};
</script>

<style scoped>
#UrgentContact {
  background: #efefef;
  min-height: 700px;
}
</style>
